
import { useState } from 'react';
import { ComplianceReport } from '@/components/compliance/reports/ReportTable';

export const useReportFilter = (reports: ComplianceReport[]) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedTab, setSelectedTab] = useState<string>('RBI');
  
  const handleTabChange = (value: string) => {
    setSelectedTab(value);
    setSearchTerm('');
  };

  // Filter reports based on search term and selected report type
  const filteredReports = reports.filter(report =>
    report.name.toLowerCase().includes(searchTerm.toLowerCase()) && 
    report.type === selectedTab
  );

  return {
    searchTerm,
    setSearchTerm,
    selectedTab,
    setSelectedTab,
    handleTabChange,
    filteredReports
  };
};
